import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useUserProfile } from "@/hooks/use-user-profile";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import OrganizationSetup from "@/components/auth/OrganizationSetup";
import LoadingFallback from "@/components/LoadingFallback";

const OrganizationSetupPage: React.FC = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { profile, isLoading: profileLoading } = useUserProfile();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate('/auth');
      return;
    }

    if (!profileLoading && profile?.organization_id) {
      navigate('/admin');
      return;
    }
  }, [authLoading, isAuthenticated, profileLoading, profile, navigate]);

  const handleSetupComplete = () => {
    navigate('/admin');
  };

  if (authLoading || profileLoading) {
    return <LoadingFallback />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <OrganizationSetup onComplete={handleSetupComplete} />;
};

export default OrganizationSetupPage;